import React, { Component } from "react";
import { Box, Select, MenuItem, FormControl, InputLabel, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField } from "@mui/material";
import Navigationbar from '../Navigationbar';

class AlertTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
          site: "",
          device: "",
          camera: "",
        };
      }

      handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
      };

  render() {
    return (
        <div>
            <Navigationbar />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2, ml: 13, height:'100vh'}}>
                {/* Filters Section */}
                <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
                 {/* Site Selection */}
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Site</InputLabel>
            <Select name="site" value={this.state.site} onChange={this.handleChange}>
              <MenuItem value="Site A">Site A</MenuItem>
              <MenuItem value="Site B">Site B</MenuItem>
              <MenuItem value="Site C">Site C</MenuItem>
            </Select>
          </FormControl>

          {/* Device Selection */}
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Device</InputLabel>
            <Select name="device" value={this.state.device} onChange={this.handleChange}>
              <MenuItem value="Device 1">Device 1</MenuItem>
              <MenuItem value="Device 2">Device 2</MenuItem>
              <MenuItem value="Device 3">Device 3</MenuItem>
            </Select>
          </FormControl>

          {/* Camera Selection */}
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Camera</InputLabel>
            <Select name="camera" value={this.state.camera} onChange={this.handleChange}>
              <MenuItem value="Camera A">Camera A</MenuItem>
              <MenuItem value="Camera B">Camera B</MenuItem>
              <MenuItem value="Camera C">Camera C</MenuItem>
            </Select>
          </FormControl>
                <TextField label="Start Date" type="date" variant="outlined" size="small" InputLabelProps={{ shrink: true }} />
                <TextField label="End Date" type="date" variant="outlined" size="small" InputLabelProps={{ shrink: true }} />
                <Button variant="contained" color="primary">Apply</Button>
                </Box>

                {/* Main Content Section */}
                <Box sx={{ display: "flex", gap: 2, width: "100%", flexGrow: 1 }}>
                {/* Left Side - Alerts Table */}
                <Box sx={{ flex: 1 }}>
                    <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                        <TableRow>
                            <TableCell>Device</TableCell>
                            <TableCell>Camera</TableCell>
                            <TableCell>Device Time</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Detection</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {/* Sample Data */}
                        <TableRow>
                            <TableCell>Device 1</TableCell>
                            <TableCell>Camera A</TableCell>
                            <TableCell>12:30 PM</TableCell>
                            <TableCell>Motion</TableCell>
                            <TableCell>Person</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Device 2</TableCell>
                            <TableCell>Camera B</TableCell>
                            <TableCell>1:45 PM</TableCell>
                            <TableCell>Intrusion</TableCell>
                            <TableCell>Unknown</TableCell>
                        </TableRow>
                        </TableBody>
                    </Table>
                    </TableContainer>
                </Box>

                {/* Right Side - Video, Buttons, and Alert Info */}
                <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2, height: "100%" }}>
                    {/* Video Stream Section */}
                    <Box sx={{ flexGrow: 8, backgroundColor: "#eaeaea", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p>Recorded video stream of selected/first camera in the list</p>
                    </Box>

                    {/* Rating Buttons Section */}
                    <Box sx={{ flexGrow: 0.2, display: "flex", gap: 2, justifyContent: "center" }}>
                    <Button variant="outlined" color="success">True Threat</Button>
                    <Button variant="outlined" color="warning">True Non-threat</Button>
                    <Button variant="outlined" color="error">False</Button>
                    </Box>

                    {/* Alert Information Section - 2 Parts */}
                    <Box sx={{ flexGrow: 2 }}>
                    <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                        <TableRow>
                            <TableCell>Alert Type</TableCell>
                            <TableCell>Timestamp</TableCell>
                            <TableCell>Outcome</TableCell>
                            <TableCell>User</TableCell>
                            <TableCell>Date Resolved</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        <TableRow>
                            <TableCell>Motion</TableCell>
                            <TableCell>2024-02-06 12:30 PM</TableCell>
                            <TableCell>Verified</TableCell>
                            <TableCell>Admin</TableCell>
                            <TableCell>2024-02-06</TableCell>
                        </TableRow>
                        </TableBody>
                    </Table>
                    </TableContainer>
                    </Box>
                </Box>
                </Box>
            </Box>
      </div>
    );
  }
}

export default AlertTab;
